import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import { App } from "@/App";
import { queryClient } from "@/config/query-client";
import { initAppVersion } from "@/app-version";
// Font is loaded as SKIN via src/shared/styles/theme.css (imported by globals.css),
// so a product can swap it without editing core.
import "@/shared/styles/globals.css";

initAppVersion();

const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error(
    "Root element not found. Make sure there is a <div id='root'></div> in your HTML."
  );
}

createRoot(rootElement).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </StrictMode>
);
